import { memo, useMemo } from "react"
import type { FC, ReactNode } from "react"
import { Grid } from "@mui/material"

import { getDevicesByAlertStatus } from "helpers/utils/devices"
import type { IDevsWRelsByIdWStates } from "types/device.types"
import PieChartSkeleton from "widgets/skeletons/PieChartSkeleton"
import { devicesAlertStatusPlotDef } from "helpers/config/dashboards/global/pies"

import useAlertSettingsWStates from "helpers/hooks/useAlertSettingsStates"
import useAlertSettings from "helpers/hooks/useAlertSettings"
import OrgPieChart from "./OrgPieChart"

const OrgPieChartMemo = memo(OrgPieChart)

interface Props {
  devsWRelsByIdWStates: IDevsWRelsByIdWStates
  subtitle?: ReactNode
}

const OrgDevicesByAlertStatusPieChart: FC<Props> = ({
  devsWRelsByIdWStates,
  subtitle,
}) => {
  const {
    orgDevicesAlertSettingsWStates,
    isLoading: statesLoading,
    isError: statesError,
  } = useAlertSettingsWStates()
  const {
    orgActiveDevicesAlertSettingsById,
    isLoading: settingsLoading,
    isError: settingsError,
  } = useAlertSettings()

  const isLoading = useMemo(
    () => statesLoading || settingsLoading,
    [settingsLoading, statesLoading],
  )
  const isError = useMemo(
    () => statesError || settingsError,
    [settingsError, statesError],
  )

  const devicesByAlertStatus = useMemo(
    () =>
      getDevicesByAlertStatus(
        devsWRelsByIdWStates,
        orgDevicesAlertSettingsWStates,
        orgActiveDevicesAlertSettingsById,
      ),
    [
      orgDevicesAlertSettingsWStates,
      devsWRelsByIdWStates,
      orgActiveDevicesAlertSettingsById,
    ],
  )

  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        {isLoading ? (
          <PieChartSkeleton />
        ) : (
          <OrgPieChartMemo
            def={devicesAlertStatusPlotDef}
            data={devicesByAlertStatus}
            isError={isError}
            subtitle={subtitle}
          />
        )}
      </Grid>
    </>
  )
}

export default OrgDevicesByAlertStatusPieChart
